
import { supabase } from "@/integrations/supabase/client";
import { GraphQLService } from "./graphqlApi";

/**
 * BatchedApi service to consolidate multiple API requests into a single call
 */
export class BatchedApiService {
  /**
   * Fetch home content in a single batch request using GraphQL-like approach
   * This consolidates multiple queries into fewer database calls with precise field selection
   */
  static async fetchHomeContentBatch(limit = 8) {
    console.log("Fetching home content in optimized GraphQL-like batch mode");
    
    // Use the GraphQL service for optimized queries
    return GraphQLService.fetchHomeContent(limit);
  }
  
  /**
   * Legacy batched API function - kept for compatibility
   * Will be deprecated in favor of the GraphQL approach
   */
  static async fetchHomeContentBatchLegacy(limit = 8) {
    console.log("Fetching home content in batch mode (legacy)");
    
    try {
      const baseQueryFields = {
        channels: 'id, name, thumbnail, logo_light, logo_dark, logo',
        playlists: '*, channels(name)',
        clips: 'id, title, thumbnail, duration, playlist_name, video_url',
        derivatives: 'id, title, thumbnail, video_url, creator_name, creator_avatar, expression_type, aspect_ratio, status, submitted_at'
      };
      
      // Execute queries in parallel with minimal field selection
      const [
        channelsResponse,
        playlistsResponse,
        popularClipsResponse,
        recentClipsResponse,
        derivativesResponse
      ] = await Promise.all([
        // Channels query
        supabase.from('channels').select(baseQueryFields.channels).order('name'),
        
        // Playlists query
        supabase.from('playlists').select(baseQueryFields.playlists).order('name'),
        
        // Popular clips query
        supabase.from('clips_with_source')
          .select(baseQueryFields.clips)
          .order('downloads', { ascending: false })
          .limit(limit),
          
        // Recent clips query
        supabase.from('clips_with_source')
          .select(baseQueryFields.clips)
          .order('created_at', { ascending: false })
          .limit(limit),
          
        // Popular derivatives query
        supabase.from('derivatives_with_details')
          .select(baseQueryFields.derivatives)
          .eq('status', 'approved')
          .order('approved_at', { ascending: false })
          .limit(limit)
      ]);
      
      return {
        channels: channelsResponse.data || [],
        playlists: playlistsResponse.data || [],
        popularClips: popularClipsResponse.data || [],
        recentClips: recentClipsResponse.data || [],
        derivatives: derivativesResponse.data || [],
        challenges: []
      };
    } catch (error) {
      console.error("Error in batch fetch:", error);
      return {
        channels: [],
        playlists: [],
        popularClips: [],
        recentClips: [],
        derivatives: [],
        challenges: []
      };
    }
  }
}
